'use strict';

var _ = require('lodash');
var DataRetrieverDefinitions = function DataRetrieverDefinitions(dataRetrieverCodeDefaults, App) {
  function mergeDefinitions(dataRetrieverCodeDefaults) {
    return _.map(dataRetrieverCodeDefaults, function (codeDefault) {
      var hepOverride = _.find(App.dataRetrievalConfigs, {
        attributes: {
          mode: codeDefault.mode,
          view: codeDefault.screen
        }
      });
      var hepProperties = _.get(hepOverride, 'properties') || {};
      return _.assign({}, codeDefault, hepProperties);
    });
  }
  return mergeDefinitions(dataRetrieverCodeDefaults);
};
DataRetrieverDefinitions.$inject = ['DataRetrieverCodeDefaults', 'App'];
module.exports = DataRetrieverDefinitions;